import React, {Component} from 'react';
import { Link } from 'react-router-dom';

import gracias from '../images/gracias.png'

export default class GraciasRegistro extends Component{
    render(){
        return(

        <section className="col-md-12 col-lg-12 bg-section">
            <div className="container bg-gracias">
                <div className="container">
                    <img src={gracias} alt="gracias" />
                    <h1>!Registro Exitoso!</h1>
                    <p>Bienvenido a la familia Dolce Salato.</p>
                    <Link to={'/login'}>Haz tu pedido hoy</Link>
                </div>
            </div>
        </section>

        )
    }
}